import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStickyNote } from "@fortawesome/free-regular-svg-icons";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

import eventEmitter from "../../../../shared/events";

const MeasuringNoteButton = (props) => {
    const icon = props.hasNotes ? faStickyNote : faPencilAlt;

    const onNoteClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        eventEmitter.emit("UPDATE_MEASURING_NOTE_SETTINGS", {
            settings: props.settings,
            binTrackingNumber: props.binTrackingNumber,
            clientCode: props.clientCode,
            shipmentKey: props.settings.shipmentKey,
            shipmentProductKey: props.settings.shipmentProductKey,
            showAll: props.showAll,
            upc: props.upc,
        });
    };

    return (
        <button className="button -text" onClick={onNoteClick}>
            <FontAwesomeIcon icon={icon} />
        </button>
    );
};

export default MeasuringNoteButton;
